import type { EnvironmentType } from '@post-office/shared-contracts/execution-runtime';

export function getHomeTwcXflowModalLink(
	envType: EnvironmentType,
	orgId: string,
	siteId: string,
	source?: string,
	context?: string,
): string {
	const homeDomain = envType === 'Production' ? 'home.atlassian.com' : 'home.stg.atlassian.com';
	const baseUrl = `https://${homeDomain}/o/${orgId}/`;
	const url = new URL(baseUrl);
	url.searchParams.set('cloudId', siteId);
	url.searchParams.set('openTwcXflowModal', 'true');
	if (source) {
		url.searchParams.set('source', source);
	}
	if (context) {
		url.searchParams.set('context', context);
	}
	return url.toString();
}
